import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { useFormContext } from 'react-hook-form';
import { cn } from '../../../utils';
import { FormErrorMessage } from '../error-message';
export const FormTextarea = ({ name, ...props }) => {
    const context = useFormContext();
    const error = context.formState.errors[name]?.message?.toString();
    return (_jsxs("div", { className: "flex flex-col gap-stack-dense", children: [_jsx("textarea", { ...context.register(name), ...props, id: name, className: cn('rounded-surface border border-border', 'p-stack min-h-24 text-body-sm text-fg-muted', 'placeholder:text-body-sm placeholder:text-fg-disabled', 'focus:outline focus:outline-2 focus:outline-border-focus focus:outline-offset-2', {
                    'border-danger text-danger placeholder:text-danger/60 focus:outline-danger': error,
                }) }), _jsx(FormErrorMessage, { error: error })] }));
};
